
export default {
  name: 'VsCarouselButton',
  inject: ['carousel'],
  props: {
    type: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: '4xl'
    },
    color: {
      type: [String, Object],
      default: 'primary'
    },
    disabledColor: {
      type: [String, Object],
      default: 'grey-light'
    },
    autoHide: {
      type: Boolean,
      default: false
    }
  },
  vessel: {
    icon: {
      cursor: 'pointer',
      $size: 'fontSize',
      $color: 'color',
      $disabled: {
        pointerEvents(val) {
          return val ? 'none' : null
        }
      }
    },
    iconDisabled: {
      $extend: 'icon',
      $color: null,
      $disabledColor: 'color'
    }
  },
  computed: {
    enabled() {
      return this.isPrev
        ? this.carousel.hasPrev
        : this.carousel.hasNext
    },
    disabled() {
      return !this.enabled
    },
    show() {
      return this.autoHide ? this.enabled : true
    },
    isPrev() {
      return this.type == 'prev'
    },
    isNext() {
      return !this.isPrev
    },
    defaultIcon() {
      return this.isPrev ? 'angle-left' : 'angle-right'
    },
    iconName() {
      return this.icon || this.defaultIcon
    },
    iconClass() {
      const vessel = this.disabled
        ? 'iconDisabled'
        : 'icon'

      return this.$vessels[vessel]
    }
  },
  methods: {
    onClick() {
      if (this.isPrev) {
        this.carousel.scrollPrev()
      } else {
        this.carousel.scrollNext()
      }
    }
  }
}
